import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-372fe9e9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "DealWithDetail" }
const _hoisted_2 = { class: "order" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "订单信息", -1))
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "info" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "more" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text" }, "更多特价推荐")
], -1))
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "area" }
const _hoisted_10 = { class: "bottomAction" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("打电话")
const _hoisted_12 = { class: "actions" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("电话联系")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "呼叫电话", -1))
const _hoisted_15 = { class: "telNum" }
const _hoisted_16 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanCell = _resolveComponent("VanCell")!
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_VanList = _resolveComponent("VanList")!
  const _component_VanImage = _resolveComponent("VanImage")!
  const _component_VanPopup = _resolveComponent("VanPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString($setup.detail.profile), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_VanCell, {
        title: "发布地区",
        value: $setup.detail.address
      }, null, 8, ["value"]),
      _createVNode(_component_VanCell, {
        title: "发布时间",
        value: $setup.detail.refreshTime
      }, null, 8, ["value"])
    ]),
    _hoisted_6,
    _createVNode(_component_VanList, {
      class: "list",
      loading: $setup.listLoading,
      "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => (($setup.listLoading) = $event)),
      finished: $setup.finished,
      onLoad: $setup.getList,
      "immediate-check": false
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "listItem",
            key: `item${idx}`,
            onClick: ($event: any) => ($setup.refresh(item))
          }, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(item.profile), 1),
            _createElementVNode("div", _hoisted_9, "地区: " + _toDisplayString(item.address), 1),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_VanButton, {
                size: "mini",
                color: "#FFCC32",
                onClick: _withModifiers(($event: any) => ($setup.getTel(item.id)), ["stop"])
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ], 8, _hoisted_7))
        }), 128))
      ]),
      _: 1
    }, 8, ["loading", "finished"]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_VanImage, {
        src: require('@/assets/img/qq_jubao.png'),
        alt: "图片",
        width: "44px",
        height: "44px",
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.router.push({name:"Report",query:{id:$setup.route.query.id}})))
      }, null, 8, ["src"]),
      _createVNode(_component_VanButton, {
        color: "#fec64b",
        block: "",
        onClick: $setup.getTel
      }, {
        default: _withCtx(() => [
          _hoisted_13
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_VanPopup, {
      class: "callDialog",
      show: $setup.isShowTel,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => (($setup.isShowTel) = $event))
    }, {
      default: _withCtx(() => [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, "是否拨打 " + _toDisplayString($setup.tel), 1),
        _createElementVNode("a", {
          class: "call",
          href: `tel:${$setup.tel}`
        }, "立即呼叫", 8, _hoisted_16)
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode($setup["RestrictDialog"], {
      modelValue: $setup.restrictShow,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.restrictShow) = $event)),
      code: $setup.restrictCode,
      type: "single"
    }, null, 8, ["modelValue", "code"]),
    _createVNode($setup["DataDoesNotExist"], {
      modelValue: $setup.isDataExist,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.isDataExist) = $event))
    }, null, 8, ["modelValue"])
  ]))
}